﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpManagerABI = void 0;
class UpManagerABI {
    static GetABI() {
        return [
            {
                "inputs": [],
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "previousManager",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "newManager",
                        "type": "address"
                    }
                ],
                "name": "ManagmentshipTransferred",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "previousOwner",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "newOwner",
                        "type": "address"
                    }
                ],
                "name": "OwnershipTransferred",
                "type": "event"
            },
            {
                "stateMutability": "payable",
                "type": "fallback"
            },
            {
                "inputs": [],
                "name": "buyBurnPool",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "createLiquidController",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "delegatedSwapper",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "tradeBot_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "liquidControllersDeployer_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "internalExchangerSP_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "buyBurnPool_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "delegatedSwapper_",
                        "type": "address"
                    }
                ],
                "name": "deployStage4",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "stabilityPool_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "internalExchangerBnB_",
                        "type": "address"
                    }
                ],
                "name": "deployStage5",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "deposit",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getBalance",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "erc20Address",
                        "type": "address"
                    }
                ],
                "name": "getBalanceToken",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getBuyBurnPoolInfrastructure",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "stabilityPool_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "tradeBot_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "rewardPool_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "priceKeeperPLS_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "internalExchangerBnB_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "delegatedSwapper_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "tokenUP_",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getInternalExchangerInfrastructure",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "rewardPool_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "buyBurnPool_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "tokenUSDL_",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "index",
                        "type": "uint256"
                    }
                ],
                "name": "getLiquidController",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "liquidController",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "count",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getLiquidControllerImmutable",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "tokenUSDL_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "llBorrower_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "llVaultManager_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "llHintHelpers_",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getLiquidControllerInfrastructure",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "priceKeeperPLS_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "delegatedSwapper_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "buyBurnPool_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "stabilityPool_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "rewardPool_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "internalExchangerBnB_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "internalExchangerSP_",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getManager",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getOwner",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getStabilityPoolInfrastructure",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "buyBurnPool_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "rewardPool_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "internalExchangerSP_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "internalExchangerBnB_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "delegatedSwapper_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "priceKeeperPLS_",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getStakingLLPoolInfrastructure",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "llStakePool_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "llStabilityPool_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "tokenUSDL_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "tokenLOAN_",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getUpdateSelectivelyArgs",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "bbPool",
                        "type": "bool"
                    },
                    {
                        "internalType": "bool",
                        "name": "sPool",
                        "type": "bool"
                    },
                    {
                        "internalType": "uint256[10]",
                        "name": "lcsIndexes",
                        "type": "uint256[10]"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "internalExchangerBnB",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "internalExchangerSP",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "contractAddress",
                        "type": "address"
                    }
                ],
                "name": "isLiquidController",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "contractAddress",
                        "type": "address"
                    }
                ],
                "name": "isValidForDelegatedSwap",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "contractAddress",
                        "type": "address"
                    }
                ],
                "name": "isValidForInternalExchanger",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "liquidControllersDeployer",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "llBorrower",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "llHintHelpers",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "llStabilityPool",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "llStakePool",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "llVaultManager",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "needUpdate",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "priceKeeperPLS",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "priceKeeperUP",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "renounceManagmentship",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "renounceOwnership",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "rewardPool",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "buyBurnPool_",
                        "type": "address"
                    }
                ],
                "name": "setBuyBurnPool",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "delegatedSwapper_",
                        "type": "address"
                    }
                ],
                "name": "setDelegatedSwapper",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "internalExchangerBnB_",
                        "type": "address"
                    }
                ],
                "name": "setInternalExchangerBnB",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "internalExchangerSP_",
                        "type": "address"
                    }
                ],
                "name": "setInternalExchangerSP",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "liquidControllersDeployer_",
                        "type": "address"
                    }
                ],
                "name": "setLiquidControllersDeployer",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "priceKeeperPLS_",
                        "type": "address"
                    }
                ],
                "name": "setPriceKeeperPLS",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "priceKeeperUP_",
                        "type": "address"
                    }
                ],
                "name": "setPriceKeeperUP",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "rewardPool_",
                        "type": "address"
                    }
                ],
                "name": "setRewardPool",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "stabilityPool_",
                        "type": "address"
                    }
                ],
                "name": "setStabilityPool",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "tradeBot_",
                        "type": "address"
                    }
                ],
                "name": "setTradeBot",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "stabilityPool",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "start",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "started",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "tokenLOAN",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "tokenUP",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "tokenUSDL",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "tradeBot",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "newManager",
                        "type": "address"
                    }
                ],
                "name": "transferManagmentship",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "newOwner",
                        "type": "address"
                    }
                ],
                "name": "transferOwnership",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "update",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "bool",
                        "name": "bbPool",
                        "type": "bool"
                    },
                    {
                        "internalType": "bool",
                        "name": "sPool",
                        "type": "bool"
                    },
                    {
                        "internalType": "uint256[]",
                        "name": "lcsIndexes",
                        "type": "uint256[]"
                    }
                ],
                "name": "updateSelectively",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "withdraw",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "erc20Address",
                        "type": "address"
                    }
                ],
                "name": "withdrawToken",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "stateMutability": "payable",
                "type": "receive"
            }
        ];
    }
}
exports.UpManagerABI = UpManagerABI;
//# sourceMappingURL=UpManagerABI.js.map